<template>
  <div class="menu_box">
    <el-menu
      ref="menu"
      text-color="#fff"
      class="el-menu-middle"
      mode="vertical"
      :menu-trigger="'click'"
      :unique-opened="true"
      @select="handleSelect"
    >
      <el-menu-item
        v-for="(item, index) in menuArr"
        :key="index"
        :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
      >
        <el-submenu
          popper-class="test"
          v-if="item.children"
          :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
          :key="index"
          :show-timeout="100"
        >
          <template slot="title">
            <span>{{ langSet == "cn" ? item.name_cn : item.name_en }}</span>
          </template>
          <el-menu-item
            v-for="(n, i) in item.children"
            :key="i"
            :index="
              langSet == 'cn'
                ? n.http_url_cn !== '/download'
                  ? n.http_url_cn
                  : n.http_url_cn + '/' + n.id
                : n.http_url_en !== '/download'
                ? n.http_url_en
                : n.http_url_en + '/' + n.id
            "
          >
            <template>
              <span slot="title">{{
                langSet == "cn" ? n.name_cn : n.name_en
              }}</span>
            </template>
          </el-menu-item>
        </el-submenu>
        <!-- 没有子菜单 -->
        <el-menu-item
          v-else
          :index="langSet == 'cn' ? item.http_url_cn : item.http_url_en"
          :key="index"
        >
          <span slot="title">{{
            langSet == "cn" ? item.name_cn : item.name_en
          }}</span>
        </el-menu-item>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import router from "../router/index.js";
import { webMenu } from "@/api/api";
export default {
  data() {
    return {
      menuArr: [],
    };
  },
  created() {
    localStorage.getItem("languageSet");
  },
  mounted() {
    // this.navDefalut();
    this.getMenu();
    this.langSet = this.$language;
  },
  computed: {},
  methods: {
    startsWithSlash(str) {
      return /^\//.test(str);
    },
    handleSelect(key, keyPath) {
      if (this.$language == "cn") {
        if (key == "Chinese") {
          this.$router.replace({
            path: "/",
          });
          return false;
        }
        if (key == "English") {
          window.open("https://www.apichina.com.cn/en/", "_blank");
          return false;
        }
      } else if (this.$language == "en") {
        if (key == "Chinese") {
          window.open("https://www.apichina.com.cn/", "_blank");
          return false;
        }
        if (key == "English") {
          this.$router.replace({
            path: "/",
          });
          return false;
        }
      }
      if (key == "Japanese") {
        this.$router.replace({
          path: "/Japanese",
        });
        return false;
      }
      if (this.$route.fullPath === key) {
        this.$emit("closeMenu");
      }
      if (keyPath.length == 1) {
        return false;
      }
      if (key) {
        if (this.startsWithSlash(key)) {
          this.$router.push({
            path: key,
          });
        } else {
          let path = window.location.protocol + "//" + key;
          window.open(path, "_blank");
        }
      }
    },
    getMenu() {
      let arr = [];
      let data = {
        page_type: 0,
      };
      webMenu(data)
        .then((res) => {
          if (res.code == 1) {
            let lists = res.data.lists;
            lists.map((item, index) => {
              if (item.is_top == "是") {
                arr.push(item);
              }
            });
            arr = [
              ...arr,
              {
                name_cn: "语言",
                name_en: "Language",
                type: "语言切换",
                children: [
                  {
                    name_cn: "中文",
                    name_en: "Chinese",
                    http_url_cn: "Chinese",
                    http_url_en: "Chinese",
                  },
                  {
                    name_cn: "英文",
                    name_en: "English",
                    http_url_cn: "English",
                    http_url_en: "English",
                  },
                  {
                    name_cn: "日文",
                    name_en: "Japanese",
                    http_url_cn: "Japanese",
                    http_url_en: "Japanese",
                  },
                ],
              },
              {
                name_cn: "个人主页",
                name_en: "Homepage",
                http_url_cn: "/personal",
                http_url_en: "/personal",
                type: "内部跳转",
                children: [
                  {
                    name_cn: "个人资料",
                    name_en: "Personal Information",
                    http_url_cn: "/personal",
                    http_url_en: "/personal",
                  },
                  {
                    name_cn: "我的收藏",
                    name_en: "My Collection",
                    http_url_cn: "/mycollect",
                    http_url_en: "/mycollect",
                  },
                  {
                    name_cn: "我的商机",
                    name_en: "My Business",
                    http_url_cn: "/mybusiness",
                    http_url_en: "/mybusiness",
                  },
                  {
                    name_cn: "评价与反馈",
                    name_en: "Comment/Feedback",
                    http_url_cn: "/feedback",
                    http_url_en: "/feedback",
                  },
                ],
              },
            ];
            this.menuArr = arr;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.menu_box {
  overflow-y: scroll;
  background: rgba(0, 0, 0, 0.6);
  .menu_title {
    color: #666;
    font-size: 14px;
    margin-left: 0.34rem;
    border-bottom: 1px #ddd solid;
  }
}
.el-menu {
  height: 80vh;
  padding: 0 0.38rem;
  box-sizing: border-box;
}
/deep/ .el-menu {
  background: transparent !important;
}
.el-menu-item {
  border-bottom: 1px solid #ffffff4d;
  font-size: 0.31rem;
  line-height: 1.19rem;
  padding: 0 !important;
  height: auto;
}
/deep/ .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  top: 28%;
}
/deep/ .el-submenu__title {
  width: 100%;
  height: 1.19rem;
  font-size: 0.31rem;
  line-height: 1.19rem;
  padding-left: 0 !important;
  background: transparent !important;
  .el-icon-arrow-down {
    margin-top: 0;
    top: 59%;
    // transform: translateY(-50%) !important;
  }
  .el-icon-arrow-down:before {
    content: "";
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #fff;
  }
}
/deep/ .el-submenu__title span {
  width: 94%;
  margin: 10px 0;
  height: 20px;
  line-height: 20px;
  display: inline-block;
  border-right: 1px solid #ffffff4d;
}
.el-menu-item:last-child {
  border-bottom: 0;
}
.menu_box {
  width: 100%;
  z-index: 10;
}
/deep/ .el-submenu {
  padding-right: 0;
  display: block;
}
/deep/ .el-menu-item:hover,
/deep/ .el-menu-item:focus {
  background: transparent !important;
}
/deep/ .el-submenu .el-menu {
  margin: 10px 0;
  border-top: 1px solid #ffffff4d;
  padding-left: 20px;
}
/deep/ .el-submenu .el-menu-item {
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.3rem !important;
  color: #fff !important;
  background: transparent !important;
  border-bottom: 0 none !important;
}
/deep/ .el-menu-middle > .el-menu-item:last-child {
  border-bottom: 1px solid #ffffff4d;
}
/deep/ .el-submenu__icon-arrow {
  right: 10px;
  font-size: 16px;
  color: #fff !important;
  font-weight: bold;
}
/deep/ .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow {
  color: #fff !important;
}
</style>